import { Injectable } from '@angular/core';
import {
  ReferenceDataConstants,
  ReferenceDataLabels,
  ReferenceDataOptionLists,
  ReferenceDataService
} from 'rome-library';
import { CaseFooterContext } from '../models/case-footer-context.model';

@Injectable({
  providedIn: 'root'
})
export class DirectFooterConfigurationService {
  public IsOnlineOfferState: boolean;
  public IsChopsState: boolean;
  public ShowCookiesPolicyLink: boolean;

  public FooterMonitoringLabel: string;
  public FooterTitleLabel: string;
  public FooterContentLabel: string;
  public OnlineOfferFooterLabel: string;

  constructor(private readonly referenceDataService: ReferenceDataService) {
    this.ShowCookiesPolicyLink = this.isShowCookiesPolicyLinkDisplayed();

    this.initState();
    this.initLabels();
  }

  private initLabels(): void {
    this.FooterMonitoringLabel = ReferenceDataLabels.DirectCustomerFooterTitle;
    this.FooterTitleLabel = ReferenceDataLabels.DirectCustomerFooterMonitoring;
    this.FooterContentLabel = ReferenceDataLabels.DirectCustomerFooterBody;
    this.OnlineOfferFooterLabel = ReferenceDataLabels.OnlineOfferFooterContent;
  }

  private initState(): void {
    this.IsChopsState = false;
    this.IsOnlineOfferState = false;
  }

  public setChopsContext(): void {
    this.IsChopsState = true;
    this.FooterContentLabel = ReferenceDataLabels.DirectCustomerCHOPSFooterBody;
  }

  public setOnlineOfferNewBusinessContext(): void {
    this.IsOnlineOfferState = true;
    this.OnlineOfferFooterLabel = ReferenceDataLabels.OnlineOfferFooterContent;
  }

  public setOnlineOfferExistingBusinessContext(): void {
    this.IsOnlineOfferState = true;
    this.OnlineOfferFooterLabel = ReferenceDataLabels.OnlineOfferFooterContentExistingBusiness;
  }

  public ensureOnlineOfferContext(): void {
    if (!this.IsOnlineOfferState) {
      this.setOnlineOfferNewBusinessContext();
    }
  }

  public updateFooterCaseContext(caseFooterContext: CaseFooterContext): void {
    this.initState();

    const isCustomerMortgageAccount =
      caseFooterContext.CaseType === ReferenceDataOptionLists.CaseTypeCustomerMortgageAccountOption;
    if (isCustomerMortgageAccount) {
      this.initLabels();
      this.FooterContentLabel = ReferenceDataLabels.DirectCustomerCHOPSFooterBody;
    } else {
      const isResidential = caseFooterContext.LoanGroupTypeCode === ReferenceDataOptionLists.LoanGroupTypeResidential;
      if (isResidential) {
        this.FooterMonitoringLabel = ReferenceDataLabels.DirectCustomerResidentialFooterTitle;
        this.FooterTitleLabel = ReferenceDataLabels.DirectCustomerResidentialFooterMonitoring;
        this.FooterContentLabel = ReferenceDataLabels.DirectCustomerResidentialFooterBody;
      } else {
        this.FooterMonitoringLabel = ReferenceDataLabels.DirectCustomerBuyToLetFooterTitle;
        this.FooterTitleLabel = ReferenceDataLabels.DirectCustomerBuyToLetFooterMonitoring;
        this.FooterContentLabel = ReferenceDataLabels.DirectCustomerBuyToLetFooterBody;
      }
    }
  }

  public setDefaultFooter(): void {
    this.initState();
    this.initLabels();
  }

  private isShowCookiesPolicyLinkDisplayed(): boolean {
    return (
      this.referenceDataService.getClientConfigurationValue(ReferenceDataConstants.DisplayCookieLink) ===
      ReferenceDataOptionLists.AnswerTypeYes
    );
  }
}
